import { render } from "./PartnerContact.vue?vue&type=template&id=7122d77b"
import script from "./PartnerContact.vue?vue&type=script&lang=js"
export * from "./PartnerContact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__